import {
    DefaultPublishDetailLevels,
    getConsumerAvailablePublishingDetailLevels,
} from '../utils/CalendarPublishingUtils';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import 'owa-calendar-sharing/lib/orchestrators/resetCalendarPublishingPermissionLinksOrchestrator';
import getCalendarPublishingStore from 'owa-calendar-sharing/lib/store/publishingStore';
import { isConsumer } from 'owa-session-store';
import * as React from 'react';
import {
    getCalendarSharingAllowablePermissions,
    getCalendarSharingPermissionsDropdownTooltip,
} from '../utils/CalendarSharingPermissionsUtils';
import {
    createNewCalendarPublishingPermission,
    updateSelectedPublishingPermission,
} from '../actions/calendarPublishing';
import strings from 'owa-strings/owa-options-strings';

export interface CalendarPublishingInviteComponentProps {
    isSendInvitePending?: boolean;
}

let styles = require('./CalendarPublishingInviteComponent.scss');

@observer
export default class CalendarPublishingInviteComponent extends React.Component<
    CalendarPublishingInviteComponentProps,
    any
> {
    public render() {
        const viewState = getCalendarPublishingStore().viewState;

        if (!viewState) {
            return null;
        }

        let { selectedPublishingPermission } = viewState;

        // if the viewState is defined, but no calendar is selected, or if there are now allowable permissions, show the controls but disable them
        let allowablePermissions = this.getAllowablePermissions();
        let disabledControls =
            !viewState.selectedPublishingItemState ||
            (!allowablePermissions || allowablePermissions.length == 0);

        let disablePublishButton =
            isConsumer() &&
            !getConsumerAvailablePublishingDetailLevels().includes(selectedPublishingPermission);

        return (
            <div className={styles.permissionContainer}>
                <Dropdown
                    className={styles.dropdownContainer}
                    selectedKey={selectedPublishingPermission ? selectedPublishingPermission : ''}
                    onChanged={(item: IDropdownOption) =>
                        updateSelectedPublishingPermission(item.key.toString())
                    }
                    placeHolder={strings.options_publishedCalendars_SelectPermissionsDropdown}
                    options={getCalendarSharingAllowablePermissions(allowablePermissions)}
                    title={
                        selectedPublishingPermission
                            ? getCalendarSharingPermissionsDropdownTooltip(
                                  selectedPublishingPermission
                              )
                            : ''
                    }
                    ariaLabel={name}
                    disabled={disabledControls}
                />
                {viewState.isNewPublishPending ? (
                    <Spinner size={SpinnerSize.small} className={styles.spinner} />
                ) : (
                    <DefaultButton
                        primary={true}
                        disabled={
                            disabledControls ||
                            !selectedPublishingPermission ||
                            disablePublishButton
                        }
                        text={strings.options_publishedCalendars_PublishButton}
                        onClick={this.handlePublishButtonClick}
                        className={styles.sharingButton}
                    />
                )}
            </div>
        );
    }

    private getAllowablePermissions = (): string[] => {
        let {
            selectedPublishingItemState,
            publishedCalendarsMap,
        } = getCalendarPublishingStore().viewState;

        let overallPermissions =
            selectedPublishingItemState && selectedPublishingItemState.AllowedDetailLevels
                ? selectedPublishingItemState.AllowedDetailLevels
                : DefaultPublishDetailLevels;

        if (isConsumer() && selectedPublishingItemState) {
            // for consumer users, allowable permissions list does not include existing published permission levels so filter those out
            let publishedCalendar = publishedCalendarsMap.get(selectedPublishingItemState.folderId);
            let existingPermissions = publishedCalendar.itemStates.map(
                itemState => itemState.CurrentDetailLevel
            );
            overallPermissions = overallPermissions.filter(
                permission => !existingPermissions.includes(permission)
            );
        }

        return overallPermissions;
    };

    private handlePublishButtonClick = () => {
        let {
            selectedPublishingItemState,
            selectedPublishingPermission,
        } = getCalendarPublishingStore().viewState;

        let permission = selectedPublishingPermission ? selectedPublishingPermission : 'Disabled';

        createNewCalendarPublishingPermission(selectedPublishingItemState.folderId, permission);
    };
}
